import { put, takeEvery, call } from "redux-saga/effects";
import moveShiftDefinition from "sc/backend/oncall/partners/shifts-definitions/move";
import {
  shiftDefinitionError,
  REQUEST_MOVE_SHIFT_DEFINITION,
  shiftDefinitionMoved,
} from "../../actions/shifts-definitions";

const requestUpdate = function*(action) {
  try {
    const result = yield call(
      moveShiftDefinition,
      action.payload.id,
      action.payload.startDate,
    );
    yield put(
      shiftDefinitionMoved(
        action.payload.id,
        result.id,
        action.payload.startDate,
      ),
    );
  } catch (error) {
    yield put(shiftDefinitionError(error.message));
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeEvery(REQUEST_MOVE_SHIFT_DEFINITION, requestUpdate);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/shifts-definitions/request-move.js